import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel, {
  ValueChangedEvent,
} from "../../../../../widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnResizeBar from "@shared/components/SnResizeBar";
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
interface Props {
  Menuprops: menuInfo;
}

const SN_PMS_PJT_REP_018 = forwardRef(({ Menuprops }: Props, ref) => {
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
  });
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const { userInfo } = global();

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({});
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  const onSearch = async () => {
    try {
      const searchInfo = searchRef.current.getFormdata();
      if (searchInfo.cd_pjt == null || searchInfo.cd_pjt == "") {
        showDialog("alter", "프로젝트를 선택해주세요.");
        return;
      }
      if (searchInfo.no_hst == null || searchInfo.no_hst == "") {
        showDialog("alter", "기준차수를 선택해주세요.");
        return;
      }
      if (searchInfo.no_hst2 == null || searchInfo.no_hst2 == "") {
        showDialog("alter", "비교차수를 선택해주세요.");
        return;
      }

      const param = {
        id: "sn_pms_pjt_rep_018_01",
        params: searchRef.current.getFormdata(),
      };
      const data: any = await fnGetDataSet(param);
      const grid1 = data[0] || [];
      const grid2 = data[1] || [];

      const { aligned1, aligned2 } = alignBoth(grid1, grid2, "no_line");

      setDataSources({
        grid1: aligned1,
        grid2: aligned2,
      });
    } catch (error) {}
  };

  const alignBoth = (list1: any[], list2: any[], key: string) => {
    const allKeys = Array.from(
      new Set([...list1.map((d) => d[key]), ...list2.map((d) => d[key])])
    ).sort();

    const map1 = new Map(list1.map((d) => [d[key], d]));
    const map2 = new Map(list2.map((d) => [d[key], d]));

    const makeEmpty = (k: any) => ({
      [key]: k,
      _isEmpty: true,
    });

    const aligned1 = allKeys.map((k) => map1.get(k) || makeEmpty(k));
    const aligned2 = allKeys.map((k) => map2.get(k) || makeEmpty(k));

    return { aligned1, aligned2 };
  };

  const onSearchPanelValueChanged = async (event: ValueChangedEvent) => {
    const { colId, rowData } = event;

    switch (colId) {
      case "cd_pjt":
        const searchInfo = searchRef.current.getFormdata();

        try {
          const params = {
            id: "sn_pms_pjt_rep_018_02",
            params: {
              cd_firm: userInfo.cd_firm,
              cd_pjt: searchInfo.cd_pjt,
            },
          };
          const data: any = await fnGetDataSet(params);

          if (data && data.length > 0) {
            rowData.fg_pjt = data[0][0].fg_pjt;
            rowData.dt_start = data[0][0].dt_start;
            rowData.dt_end = data[0][0].dt_end;
            rowData.am_k = data[0][0].am_k;

            const combo =
              data[0]?.map((item: any) => ({
                code: item.no_hst,
                name: item.nm_hst,
              })) || [];

            setFormControlData((prev) =>
              prev.map((ctrl) =>
                ctrl.cd_param === "no_hst" || ctrl.cd_param === "no_hst2"
                  ? { ...ctrl, js_combo: combo }
                  : ctrl
              )
            );
          }
        } catch (e) {
          console.error(e);
        }
        break;
    }
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div>
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          onValueChanged={onSearchPanelValueChanged}
        />
      </div>

      <div className="flex flex-1">
        <SnResizeBar direction={"width"} id="panel1" orgSize="50%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{ rowSelection: "single", title: "기준차수" }}
          />
        </SnResizeBar>

        <SnResizeBar direction={"width"} id="panel2" orgSize="50%">
          <SnGrid
            ref={gridRefs.current["grid2"]}
            columnConfig={grids.grid2.columns}
            rowData={grids.grid2.dataSource}
            etcProps={{ rowSelection: "multiple", title: "비교차수" }}
          />
        </SnResizeBar>
      </div>
    </div>
  );
});

export default SN_PMS_PJT_REP_018;
